module.exports = __webpack_public_path__ + "img/mistakesText11.227eabb3.png";